import React from "react";
// Import Swiper styles
import 'swiper/css';
import './socialnew.css';
import instaimg from "../assets/img/instagram.png";
import facebookimg from "../assets/img/facebook.png";
import linkedinimg from "../assets/img/linkedin.png";
// import twitterimg from "../assets/img/twitter.png";
import youtubeimg from "../assets/img/youtube.png";
import websiteImage from "../assets/img/websiteImage.png";

function ConnectWithUs() {
    return (
        <React.Fragment>
            <h3>Connect with us</h3>
            <div className="contact-social2">

                <a href="https://vitapaa.netlify.app/">
                    <div className="sbox2 instagram">
                        <img src={websiteImage} className="img-fluid" alt="instagram icon" />
                        <p>Website</p>
                    </div>
                </a>

                <a href="https://www.instagram.com/test_alumni/">
                    <div className="sbox2 instagram">
                        <img src={instaimg} className="img-fluid" alt="instagram icon" />
                        <p>Instagram</p>
                    </div>
                </a>

                <a href="https://www.facebook.com/vitap.coordalumni">
                    <div className="sbox2 facebook">
                        <img src={facebookimg} className="img-fluid" alt="Facebook icon" />
                        <p>Facebook</p>
                    </div>
                </a>


                <a href="https://www.linkedin.com/in/vitap-alumni-591849218/">
                    <div className="sbox2 linkedin">
                        <img src={linkedinimg} className="img-fluid" alt="Linkedin Icon" />
                        <p>Linked In</p>
                        </div>
                </a>
                
                {/* <div className="sbox2 twitter">
                    <img src={twitterimg} className="img-fluid" alt="twitter icon" />
                    <p>Twitter</p>
                </div> */}

                <a href="https://www.youtube.com/c/VITAP">
                    <div className="sbox2 youtube">
                        <img src={youtubeimg} className="img-fluid" alt="youtube icon" />
                        <p>Youtube</p>
                    </div>
                </a>
               
            </div>
        </React.Fragment>
    );
}
export default ConnectWithUs;